import { Injectable } from '@angular/core';
import { BaseService } from '../abstracts/base.service';
import { NoteModel } from '../models/note.model';
import { ResultModel } from '../models/result.model';

@Injectable({
  providedIn: 'root'
})
export class NoteService extends BaseService {


  listAllForSelect() {
    return this.httpClient.get<ResultModel<NoteModel[]>>(this.getApiUrl('notes'));
  }

  listAll(note: NoteModel) {
    var formData = new FormData;
    formData.append('IdentifierID', note.IdentifierID);
    formData.append('IdentifierType', note.IdentifierType);

    return this.httpClient.post<ResultModel<NoteModel[]>>(this.getApiUrl(`notes/tenant/${note.IdentifierID}`), formData);
  }

  create(note: NoteModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('notes'), note);
  }


  deleteNote(noteID) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl(`notes/${noteID}`));
  }
}
